import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { putInterest } from '../../actions';
import IconMenuCell from './IconMenuCell';
import { columnNameStyle, columnIconMenuCellStyle, columnIsDefaultInterestStyle } from './index';
import TableRow from 'material-ui/Table/TableRow';
import TableRowColumn from 'material-ui/Table/TableRowColumn';
import Checkbox from 'material-ui/Checkbox';
import InterestItemList from './InterestItemList';

const onCheckIsDefault = (interestId, action) => (event, isInputChecked = false) => {
    action(interestId, { isDefault: isInputChecked });
};

const InterestRow = ({
    id = '',
    interest: { name = '', isDefault = false, ttIds = [], teamIds = [] } = {
        name: '',
        isDefault: false,
        ttIds: [],
        teamIds: []
    },
    tournaments = {},
    teams = {},
    putInterest,
    ...otherProps
}) => {
    const tableProps = { ...otherProps };
    Reflect.deleteProperty(tableProps, 'dispatch');

    columnIsDefaultInterestStyle.paddingLeft = '19px';
    columnIsDefaultInterestStyle.textAlign = 'left';

    return (
        <TableRow {...tableProps}>
            <TableRowColumn style={columnNameStyle}>{name}</TableRowColumn>
            <TableRowColumn>
                <InterestItemList title="Teams: " itemIdList={teamIds} mapItems={teams} />
                <InterestItemList title="Tournaments: " itemIdList={ttIds} mapItems={tournaments} />
            </TableRowColumn>
            <TableRowColumn style={columnIsDefaultInterestStyle}>
                <Checkbox defaultChecked={isDefault} onCheck={onCheckIsDefault(id, putInterest)} />
            </TableRowColumn>
            <TableRowColumn style={columnIconMenuCellStyle}>
                <IconMenuCell interestId={id} />
            </TableRowColumn>
        </TableRow>
    );
};

InterestRow.propTypes = {
    id: PropTypes.string.isRequired,
    interest: PropTypes.shape({
        name: PropTypes.string.isRequired,
        isDefault: PropTypes.bool,
        ttIds: PropTypes.array,
        teamIds: PropTypes.array
    }).isRequired,
    tournaments: PropTypes.object,
    teams: PropTypes.object,
    putInterest: PropTypes.func.isRequired
};

export default connect(
    ({ requery }, { id }) => ({
        interest: requery.entities && requery.entities.userInterests && requery.entities.userInterests[id],
        tournaments: requery.entities && requery.entities.tournaments,
        teams: requery.entities && requery.entities.teams
    }),
    { putInterest }
)(InterestRow);



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/InterestsTable/InterestRow.js
 **/